import '/app/brewery-packages/content/content-editor-plugin-emphasis/src/Emphasis.css-raw';
export default {
  "emphasis": "news-4a753f38-emphasis-Ihm-DG"
};